import { render, staticRenderFns } from "./CountStatistics.vue?vue&type=template&id=5089db0c&scoped=true"
import script from "./CountStatistics.vue?vue&type=script&lang=js"
export * from "./CountStatistics.vue?vue&type=script&lang=js"
import style0 from "./CountStatistics.vue?vue&type=style&index=0&id=5089db0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5089db0c",
  null
  
)

export default component.exports